
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scheduler",
      function () {
        return require("private-next-pages/scheduler.tsx");
      }
    ]);
  